/**
 * Для добавления вертикального пустого пространства
 * @param props
 * @component
 * @category Component
 * @example
 * ```tsx
 * import {VSpace} from "~/shared/ui";
 *
 * function Example() {
 *     return (
 *         <>
 *             <div>Строка 1</div>
 *             <VSpace/>
 *             <div>Строка 2</div>
 *             <VSpace size={2}/>
 *             <div>Строка 3</div>
 *             <VSpace size="2rem"/>
 *             <div>Строка 4</div>
 *         </>
 *     )
 * }
 * ```
 */
export function VSpace({
	size = "2rem",
}: {
	/**
	 * Размер пространства. Если указано число, то будет использоваться ед. изм. `rem`. Можно использовать `calc`
	 * @defaultValue '2rem'
	 */
	size?: string | number
}) {
	return (
		<div
			style={{
				height: typeof size === "number" ? `${size}rem` : size,
			}}
		></div>
	)
}
